(() => {
  const settings = document.currentScript?.dataset;
  const label = settings?.wishlistLabel;
  if (!label) return;
  let activePanel = null;
  let returnFocus = null;
  const update = () => {
    const button = document.getElementById('oxi-main-float-btn');
    if (button) {
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
      button.setAttribute('aria-haspopup', 'dialog');
      button.querySelectorAll('svg').forEach(icon => {
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
      });
    }
    let nextPanel = null;
    document.querySelectorAll('#oxi-wl-popup, #oxi-wl-sidebar').forEach(panel => {
      const open = panel.classList.contains('active');
      panel.inert = !open;
      panel.setAttribute('aria-hidden', String(!open));
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      const heading = panel.querySelector('h3');
      if (heading) {
        heading.id = panel.id + '-title';
        panel.setAttribute('aria-labelledby', heading.id);
      }
      const close = panel.querySelector('.oxi-wl-close');
      if (close) {
        close.type = 'button';
        if (settings.closeLabel) close.setAttribute('aria-label', settings.closeLabel);
      }
      if (open) nextPanel = panel;
    });
    button?.setAttribute('aria-expanded', String(Boolean(nextPanel)));
    if (nextPanel && nextPanel !== activePanel) {
      returnFocus = document.activeElement;
      requestAnimationFrame(() => {
        if (nextPanel.classList.contains('active')) nextPanel.querySelector('.oxi-wl-close')?.focus({preventScroll:true});
      });
    } else if (!nextPanel && activePanel && returnFocus?.isConnected) {
      returnFocus.focus({preventScroll:true});
    }
    activePanel = nextPanel;
  };
  const connect = host => {
    new MutationObserver(update).observe(host, {
      childList:true, subtree:true, attributes:true, attributeFilter:['class']
    });
    update();
  };
  const host = document.querySelector('[id$="__6038938367790878235"]');
  if (host) connect(host);
  else {
    const discovery = new MutationObserver(() => {
      const container = document.getElementById('oxi-floating-button-container')?.parentElement;
      if (!container) return;
      discovery.disconnect();
      connect(container);
    });
    discovery.observe(document.body, {childList:true, subtree:true});
  }
  // Oxi's auto-injection can append its button inside the theme's submit button.
  // Keep it as a separate, non-submit control without replacing app handlers.
  const main = document.getElementById('MainContent');
  const repairProductButton = () => {
    const buttons = main?.querySelectorAll('.oxi-wl-auto-injected-btn');
    if (!buttons?.length) return false;
    buttons.forEach(button => {
      button.type = 'button';
      const submit = button.parentElement?.closest('button[type="submit"], button[data-add-to-cart]');
      if (submit) submit.insertAdjacentElement('afterend', button);
    });
    return true;
  };
  if (main && !repairProductButton()) {
    const injection = new MutationObserver(() => {
      if (repairProductButton()) injection.disconnect();
    });
    injection.observe(main, {childList:true, subtree:true});
  }
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || !activePanel) return;
    const controls = [...activePanel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex="0"]')]
      .filter(element => !element.closest('[inert]') && element.getClientRects().length);
    if (!controls.length) return;
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || !activePanel.contains(document.activeElement))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !activePanel.contains(document.activeElement))) {
      event.preventDefault(); first.focus();
    }
  });
})();
